import { FC } from 'react';

import { Page, PageHeader } from '@/components';
import { withLoader, WithLoaderProps } from '@/hocs';
import { DomesticIncidentReportTable } from '@/pages/Tools/DomesticIncidentReport/Tables/DomesticIncidentReportTable';

const DomesticIncidentReportPage: FC<WithLoaderProps> = () => {
  return (
    <Page>
      <PageHeader title="Domestic incident reports" backRoute="/tools" />

      <DomesticIncidentReportTable />
    </Page>
  );
};

export default withLoader(DomesticIncidentReportPage);
